import React from 'react';
import { ThemeContext } from '@surveycake/rc';
import { useSurveyConfig } from 'app/core/survey-config';
import { usePreviewMessageEvent } from 'app/modules/survey';
import Pages from './pages';
import { useGlobalStyles } from './styles';

function App() {
  const { theme } = useSurveyConfig();

  usePreviewMessageEvent();
  useGlobalStyles(theme);

  return (
    <ThemeContext.Provider value={theme}>
      <Pages />
    </ThemeContext.Provider>
  );
}

export default App;
